import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var AssetImageIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15l-14,0l0,-11l14,0l0,11Zm-1,-10l-12,0l0,9l12,0l0,-9Zm-11,8l10,0c0,0 -0.013,-2.744 0,-3c-0.266,-0.682 -0.776,-1.17 -2,-1c-3.37,0.468 -2.662,3.041 -6,2c-1.066,-0.332 -2.006,0.357 -2,2Zm2.483,-6c0.818,0 1.483,0.664 1.483,1.483c0,0.818 -0.665,1.483 -1.483,1.483c-0.819,0 -1.483,-0.665 -1.483,-1.483c0,-0.819 0.664,-1.483 1.483,-1.483Z"
  }));
});
AssetImageIcon.displayName = 'AssetImageIcon';
export default AssetImageIcon;